import { useRecoilState } from "recoil";
import { mostrarCauc } from "../atom";

const useMostrarCaucState = () => {
    return useRecoilState(mostrarCauc);
};

export default useMostrarCaucState;